import React from "react";
import { Container, Box, Typography } from "@mui/material";
import { Card } from "react-bootstrap";
import { theme } from "../../../theme";
import { assets } from "../../../assets";

function SuccessPage({ url }) {
  setTimeout(() => {
    window.location.href = url;
  }, [3000]);
  return (
    <Card
      sx={{
        boxShadow: theme.palette.boxShadow,
        borderRadius: "10px",
        padding: "5px 10px",
        position: "relative",
        width: "100%",
        height: "100%",
        bgcolor: "#ffffff",
        p: 3,
      }}
    >
      <Container
        className="d-flex align-items-center justify-content-center"
        style={{ minHeight: "250px" }}
      >
        <Box textAlign="center" py={3}>
          <img
            src={assets?.success}
            style={{ height: "200px" }}
            className="mb-3"
            alt=""
          />
          <Typography
            variant="h5"
            component="h1"
            fontWeight={"bold"}
            gutterBottom
          >
            সফল!
          </Typography>

          <Typography>আপনার পেমেন্ট সফলভাবে সম্পন্ন হয়েছে।</Typography>
        </Box>
      </Container>
    </Card>
  );
}

export default SuccessPage;
